import EmpresaService from "../../services/EmpresaService";
import * as empresaActions from "./Store";
import store from "../../store";
import { exibirNotificacao } from "../../features/mensagemAlerta/redux/mensagemAlertaActions";

export const obterDadosEmpresa = (apelidoEmpresa, idEmpresa) => async dispatch => {
  const retorno = await obterEmpresa(apelidoEmpresa, idEmpresa);

  if (retorno) {
    inserirEmpresaRedux(retorno, dispatch);
  }

  return retorno;
};

export const listarEmpresasHelp = () => async dispatch => {
  const empresas = await EmpresaService.listarEmpresasHelp()
    .then(resposta => resposta.data)
    .catch(error =>
      store.dispatch(
        exibirNotificacao(
          error?.response?.data?.mensagem ||
            "Ocorreu um erro ao listar as empresas do help de exames."
        )
      )
    );

  dispatch(empresaActions.inserirListaEmpresasHelp(empresas));
};

export const obterDadosEmpresaSemIncluirNoRedux = async (apelidoEmpresa, idEmpresa) => {
  return await obterEmpresa(apelidoEmpresa, idEmpresa);
};

const obterEmpresa = async (apelidoEmpresa, idEmpresa) => {
  return await EmpresaService.obterDadosEmpresa(apelidoEmpresa, idEmpresa)
    .then(resposta => resposta.data)
    .catch(error =>
      store.dispatch(
        exibirNotificacao(
          error?.response?.data?.mensagem ||
            "Ocorreu um erro ao buscar os dados da empresa pelo apedido."
        )
      )
    );
};

const inserirEmpresaRedux = (empresa, dispatch) => {
  dispatch(
    empresaActions.inserirDadosEmpresa({
      empresa
    })
  );
};
